// extracted by mini-css-extract-plugin
module.exports =  {"enumeration":"Enumeration-module__enumeration___fP33Y"};